import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-phonefield', 'INVALID', 'The phone number entered is invalid.');
Labels.set('ui-phonefield', 'CHOOSE_COUNTRY', 'Select country');
Labels.set('ui-phonefield', 'PHONENR', 'Phone number');
